'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';
import { IconCircle } from '@tabler/icons-react';
import { RadioGroup as RadioGroupPrimitive } from 'radix-ui';

function RadioGroup({ className, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return <RadioGroupPrimitive.Root data-slot='radio-group' className={cn('grid gap-3', className)} {...props} />;
}

function RadioGroupItem({ className, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot='radio-group-item'
      className={cn(
        'aspect-square size-4 shrink-0 rounded-full border border-brand-input text-brand-primary shadow-xs transition-[color,background-color,border-color,box-shadow] outline-none focus-visible:border-brand-ring focus-visible:ring-[3px] focus-visible:ring-brand-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-brand-destructive aria-invalid:ring-brand-destructive/20 data-[state=checked]:border-primary-green-day data-[state=checked]:bg-primary-green-day',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot='radio-group-indicator'
        className='relative flex items-center justify-center'
      >
        <IconCircle className='absolute top-1/2 start-1/2 size-2 -translate-x-1/2 rtl:translate-x-1/2 -translate-y-1/2 fill-white text-white' />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
